import 'vuetify/styles'
import {h} from 'vue'
import {createVuetify} from 'vuetify'
import type {IconSet, IconProps} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import {aliases} from 'vuetify/iconsets/md'

const symbols = (fill: boolean): IconSet => ({
  component: (props: IconProps) =>
    h(
      props.tag,
      {
        class: 'material-symbols-outlined',
        style: fill ? {fontVariationSettings: "'FILL' 1"} : undefined,
      },
      props.icon as string
    ),
})

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'ms',
    aliases,
    sets: {ms: symbols(false), msf: symbols(true)},
  },
})
